import React from 'react';
import FromServer from './FromServer';
import { Divider, Grid, Checkbox } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import LocalStorage from '../../providers/LocalStorage';
import DocumenteList from '../../commons/DocumenteList';
import Utils from '../../providers/Utils';
import AlertDialog from '../../commons/dialogs/AlertDialog';
import CustomAppBar from '../../commons/AppBar';
import wordIcon from '../../Pics/wordDoc.png'
import pdfIcon from '../../Pics/iconsMonitorizare/pdf.png'
import imgIcon from '../../Pics/iconsMonitorizare/img.png'
import excellIcon from '../../Pics/iconsMonitorizare/excell.png'

import DrepturiAcces from '../drepturiacces/DrepturiAcces';
import AlertNew from '../../commons/dialogs/AlertNew';

// import { ReactComponent as PDFSvg } from '../../Pics/PDF.svg'




export default class DocumenteProiecte extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listDocumente: [],
            objFile: {},
            isOpenAlert: false,
            proiecteCheck: false,
            etapeCheck: false,
            taskuriCheck: false,
            listFiltered: [],
            filterBy: [],
            fullScreen: false,
            listAllDocs: [],
            proiecteDocs: 0,
            alertView: false
        }
    }

    //'Upload/DocTask'

    // adresaMedia/Proiecte/Docs

    // adresaMedia/Taskuri/Docs
    drepturiAcces = new DrepturiAcces()

    componentDidMount() {
        this.getDocumente()
        this.getWindowDimentions()
    }


    getDocumente = async () => {
        let fs = new FromServer()

        let u = new Utils()

        let ws = new Ws()

        let _getProiecte = ws.customSelect('select * from proiecte where isnull(sters,0) != @p1 order by id desc', {
            p1: 1
        })

        let getDocumente = fs.getDocumente()

        let documenteTaskuri = ws.customSelect('select d.*, t.titlu as nume_t  from taskuri_documente d left join taskuri t on d.id_task = t.id where  isnull(d.sters,0) !=1 ', {
            p1: this.props.idproiect
        })

        let documenteEtape = ws.customSelect('select d.*, e.denumire as nume_t from etape_documente d left join proiecte_etape e on d.id_etapa = e.id  where isnull(sters,0) != 1', {
            p1: this.props.idproiect
        })

        let documenteCosturi = ws.customSelect(`select c.* , ct.id_task, t.id_proiect from costuri_taskuri_rows_documente c left join
                                                 costuri_taskuri_rows r on c.id_row_cost = r.id left join 
                                                 costuri_taskuri ct on ct.id = r.id_cost left join taskuri t on t.id = ct.id_task where isnull(c.sters, 0 ) != 1 `, {
            p1: 1
        })

        let documenteBugete = ws.customSelect(`select c.* , ct.id_task, t.id_proiect from bugete_taskuri_rows_documente c left join 
                                                bugete_taskuri_rows r on c.id_row_cost = r.id left join
                                                 bugete_taskuri ct on ct.id = r.id_cost left join taskuri t on t.id = ct.id_task  where isnull(c.sters, 0 ) != 1`, {
            p1: 1
        })

        let [p, t, e, getProiecte, docRowsC, docRowsB] = await Promise.all([getDocumente, documenteTaskuri, documenteEtape, _getProiecte, documenteCosturi, documenteBugete])

        console.log('p :>> ', p);
        console.log('t :>> ', t);
        console.log('e :>> ', e);
        console.log('docRowsC :>> ', docRowsC);
        console.log('docRowsC :>> ', docRowsB);

        if (p.Succes && t.Succes && getProiecte.Succes) {

            let proiecte = getProiecte.Content

            let doc = p.Content

            let docT = t.Content

            let docE = e.Content

            let docEl = docE.length

            let docTl = docT.length

            let docL = doc.length

            let docRC = [...docRowsC.Content]

            let docRB = [...docRowsB.Content]

            let docRCL = docRC.length

            let docRBL = docRB.length

            let allDocs = []

            let allProjects = []

            let proiecteDocs = 0




            if (doc.length > 0) {
                for (let i = 0; i < docL; i++) {

                    doc[i].cand_uploadat = u.ParseDataFromSql(doc[i].cand_uploadat)
                    doc[i].doc_info = 'Proiecte'
                    let type = doc[i].nume.split('.')
                    doc[i].type = type[1]
                    doc[i].active = false
                    doc[i].idul = allDocs.length + 1
                    allDocs.push(doc[i])
                }
            }

            if (docT.length > 0) {
                for (let i = 0; i < docTl; i++) {
                    docT[i].cand_uploadat = u.ParseDataFromSql(docT[i].cand_uploadat)
                    docT[i].doc_info = 'Taskuri'
                    let type = docT[i].nume.split('.')
                    docT[i].type = type[1]
                    docT[i].active = false
                    docT[i].idul = allDocs.length + 1
                    allDocs.push(docT[i])
                }

            }

            if (docRCL > 0) {

                for (let i = 0; i < docRCL; i++) {
                    docRC[i].cand_uploadat = u.ParseDataFromSql(docRC[i].cand_uploadat)
                    docRC[i].doc_info = 'DocCosturi'
                    let type = docRC[i].nume.split('.')
                    docRC[i].type = type[1]
                    docRC[i].active = false
                    docRC[i].idul = allDocs.length + 1

                    console.log('docRC[i] :>> ', docRC[i]);
                    allDocs.push(docRC[i])
                }

            }

            if (docRBL > 0) {

                for (let i = 0; i < docRBL; i++) {
                    docRB[i].cand_uploadat = u.ParseDataFromSql(docRB[i].cand_uploadat)
                    docRB[i].doc_info = 'DocBugete'
                    let type = docRB[i].nume.split('.')
                    docRB[i].type = type[1]
                    docRB[i].active = false
                    docRB[i].idul = allDocs.length + 1

                    console.log('docRB[i] :>> ', docRB[i]);
                    allDocs.push(docRB[i])
                }

            }

            if (docE.length > 0) {
                for (let i = 0; i < docEl; i++) {
                    docE[i].cand_uploadat = u.ParseDataFromSql(docE[i].cand_uploadat)
                    docE[i].doc_info = 'Etape'
                    let type = docE[i].nume.split('.')
                    docE[i].type = type[1]
                    docE[i].active = false
                    docE[i].idul = allDocs.length + 1
                    allDocs.push(docE[i])
                }

            }

            console.log('allDocs :>> ', allDocs);

            for (let i = 0, n = proiecte.length; i < n; i++) {

                let proiecteDoc = allDocs.filter(p => p.id_proiect === proiecte[i].id)

                if (proiecteDoc.length > 0) {

                    proiecteDocs += proiecteDoc.length
                    proiecte[i].docs = proiecteDoc
                    proiecte[i].showAllDocs = false

                    allProjects.push(proiecte[i])
                }
            }

            console.log('allProjects :>> ', allProjects);

            console.log('allDocs :', allDocs);
            this.setState({
                listFiltered: allDocs,
                listDocumente: allDocs,
                listAllDocs: allProjects,
                proiecteDocs: proiecteDocs,
                alertView: this.drepturiAcces.getDrepturiAplicatie().acces_extins_proiecte ? false : true
            })
        }

    }

    selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }

    uploadDoc = async (id, idProiect) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/DocProiect', saveFile, idProiect);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.getDocumente()
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }
    }


    deleteFile = (f) => {
        this.setState({
            objFile: f,
            isOpenAlert: true
        })
    }

    deleteDoc = async () => {

        let ws = new Ws();

        let ls = new LocalStorage()
        let u = new Utils()

        let deleteFile = await ws.update('proiecte_documente', {
            sters: 1,
            cand_sters: u.defaultData(),
            cine_sters: ls.GetUserData().InfoUser.IdUser
        },
            { id: this.state.objFile.id })
        if (deleteFile.Succes) {

            this.setState({
                isOpenAlert: false
            }, () => {
                this.getDocumente()
            })

            // console.log('get docs :');

        }

    }

    goToFile = (f) => {
        let adresaFisa = new Ws().adresaMedia + `/${f.doc_info}/Docs/${f.token}`

        window.open(adresaFisa)
    }

    changeProiect = (ev) => {
        let clonefilterBy = [...this.state.filterBy]
        // console.log('ev.target.checked :', ev.target.checked);
        if (ev.target.checked === true) {


            clonefilterBy.push({ id: 1, nume: 'Proiect' })




        } else {
            let idx = clonefilterBy.findIndex(i => i.id === 1)
            clonefilterBy.splice(idx, 1)
        }

        // console.log('clonefilterBy :', clonefilterBy);
        let cloneProiecte = [...this.state.listDocumente]

        // console.log('cloneProiecte :', cloneProiecte);

        let filterList = cloneProiecte.filter((p) => {
            if (clonefilterBy.length === 0) { return true; }

            for (let i = 0, n = clonefilterBy.length; i < n; i++) {
                if (p.doc_info === clonefilterBy[i].nume) {
                    return true;
                    break
                }
            }
        })

        // console.log('filterList :', filterList);

        this.setState({
            listFiltered: filterList,
            filterBy: clonefilterBy,
            proiecteCheck: ev.target.checked
        })



    }


    changeTaskuri = (ev) => {
        let clonefilterBy = [...this.state.filterBy]


        // console.log('ev.target.checked :', ev.target.checked);
        if (ev.target.checked === true) {


            clonefilterBy.push({ id: 2, nume: 'Task' })




        } else {
            let idx = clonefilterBy.findIndex(i => i.id === 2)
            clonefilterBy.splice(idx, 1)
        }

        // console.log('clonefilterBy :', clonefilterBy);
        let cloneProiecte = [...this.state.listDocumente]

        // console.log('cloneProiecte :', cloneProiecte);

        let filterList = cloneProiecte.filter((p) => {
            if (clonefilterBy.length === 0) { return true; }

            for (let i = 0, n = clonefilterBy.length; i < n; i++) {
                if (p.doc_info === clonefilterBy[i].nume) {
                    return true;
                    break
                }
            }
        })

        // console.log('filterList :', filterList);

        this.setState({
            listFiltered: filterList,
            filterBy: clonefilterBy,
            taskuriCheck: ev.target.checked
        })

    }

    changeEtape = (ev) => {
        let clonefilterBy = [...this.state.filterBy]


        // console.log('ev.target.checked :', ev.target.checked);
        if (ev.target.checked === true) {


            clonefilterBy.push({ id: 3, nume: 'Etapa' })




        } else {
            let idx = clonefilterBy.findIndex(i => i.id === 3)
            clonefilterBy.splice(idx, 1)
        }

        // console.log('clonefilterBy :', clonefilterBy);
        let cloneProiecte = [...this.state.listDocumente]

        // console.log('cloneProiecte :', cloneProiecte);

        let filterList = cloneProiecte.filter((p) => {
            if (clonefilterBy.length === 0) { return true; }

            for (let i = 0, n = clonefilterBy.length; i < n; i++) {
                if (p.doc_info === clonefilterBy[i].nume) {
                    return true;
                    break
                }
            }
        })

        // console.log('filterList :', filterList);

        this.setState({
            listFiltered: filterList,
            filterBy: clonefilterBy,
            etapeCheck: ev.target.checked
        })




    }


    getWindowDimentions = () => {
        let windowWidth = window.innerWidth


        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        })

    }

    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }




    seeAllDocs = (p) => {
        let projects = [...this.state.listAllDocs]

        let idx = projects.findIndex(pr => pr.id === p.id)

        if (idx !== -1) {
            projects[idx].showAllDocs = !projects[idx].showAllDocs

            this.setState({ listAllDocs: projects })
        }
    }


    docActive = (d, p) => {

        let projects = [...this.state.listAllDocs]



        let idxP = projects.findIndex(pr => pr.id === p.id)

        if (idxP !== -1) {

            let idxD = projects[idxP].docs.findIndex(doc => doc.idul === d.idul)

            if (idxD !== -1) {
                projects[idxP].docs[idxD].active = !projects[idxP].docs[idxD].active
                this.setState({ listAllDocs: projects })
            }

        }
    }


    viewDoc = (d, p) => {

        let projects = [...this.state.listAllDocs]



        let idxP = projects.findIndex(pr => pr.id === p.id)

        if (idxP !== -1) {

            let idxD = projects[idxP].docs.findIndex(doc => doc.idul === d.idul)

            if (idxD !== -1) {
                projects[idxP].docs[idxD].active = false
                this.setState({ listAllDocs: projects }, () => {
                    this.goToFile(d)
                })
            }

        }
    }

    deleteDoc = async (d) => {

        let ws = new Ws()

        if (d.doc_info === 'Proiecte') {

            let delDoc = await ws.update('proiecte_documente', { sters: 1 }, { id: d.id })

            if (delDoc.Succes) {
                this.getDocumente()
            }

        } else if (d.doc_info === 'Etape') {
            let delDoc = await ws.update('etape_documente', { sters: 1 }, { id: d.id })

            if (delDoc.Succes) {
                this.getDocumente()
            }
        } else if (d.doc_info === 'Taskuri') {
            let delDoc = await ws.update('taskuri_documente', { sters: 1 }, { id: d.id })

            if (delDoc.Succes) {
                this.getDocumente()
            }
        } else if (d.doc_info === 'DocCosturi') {
            let delDoc = await ws.update('costuri_taskuri_rows_documente', { sters: 1 }, { id: d.id })

            if (delDoc.Succes) {
                this.getDocumente()
            }
        } else if (d.doc_info === 'DocBugete') {
            let delDoc = await ws.update('bugete_taskuri_rows_documente', { sters: 1 }, { id: d.id })

            if (delDoc.Succes) {
                this.getDocumente()
            }
        }


    }


    returnImg = (type) =>{

        if(type.includes('doc')){
            return (<img style={{ height: 50, width: 40 }} src={wordIcon} />)
        }else if(type.includes('pdf') ){
            return (<img style={{ height: 50, width: 40 }} src={pdfIcon} />)
        }else if(type.includes('xls') ){
            return (<img style={{ height: 50, width: 40 }} src={excellIcon} />)
        }else {
            return (<img style={{ height: 50, width: 40 }} src={imgIcon} />)
        }
    }



    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={' '} appBarButtons={this.buildAppBarButtons()} />
                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.documenteProiecte.managementDocumente} </h1>
                        <h5 style={{ textAlign: 'left', fontWeight: 400 }}>{this.state.listAllDocs.length} {this.dictionary.documenteProiecte.proiecte} {this.state.proiecteDocs} {this.dictionary.documenteProiecte.documente}</h5>
                    </Grid>


                    {this.state.listAllDocs.map((p, idxP) => {
                        return (
                            <Grid key={idxP} container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 20, fontWeight: 500, color: 'black', marginBottom: 40 }}>
                                        {p.titlu}

                                    </h4>
                                </Grid>

                                {p.docs.map((d, idxD) => {


                                    if (p.showAllDocs) {
                                        if (d.active) {
                                            return (
                                                <Grid key={idxD} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <Grid style={{ width: '95%', margin: 'auto', backgroundColor: 'rgb(249	249	249)', marginBottom: 20, padding: '10px', cursor: 'pointer' }} container>
                                                        <Grid onClick={() => { this.docActive(d, p) }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                          {this.returnImg(d.type)}

                                                        </Grid>

                                                        <Grid onClick={() => { this.docActive(d, p) }} style={{ textAlign: 'left', paddingLeft: 10 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            <span style={{ fontSize: 14, fontWeight: 600 }}>{d.nume}</span><br />
                                                            <span style={{ color: 'gray', fontSize: 14 }}>{d.type.toUpperCase()}</span>
                                                        </Grid>

                                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                            <span style={{ fontSize: 14, fontWeight: 400 }}>{new Utils().dataPrescurtataRomana(d.cand_uploadat)}</span><br />
                                                            <span style={{ fontSize: 14 }}>{d.nume_t}</span>
                                                        </Grid>

                                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                            <div style={{ borderLeft: '1px solid gray', height: "100%" }}>
                                                                <div style={{ display: 'inline-block', height: 'fit-content', marginTop: '24%' }}>
                                                                    <i onClick={() => { this.viewDoc(d, p) }} style={{ marginRight: 10 }} className='material-icons'>visibility</i>
                                                                    <i onClick={() => { this.deleteDoc(d) }} className='material-icons'>delete</i>
                                                                </div>


                                                            </div>
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            )
                                        } else {
                                            return (
                                                <Grid key={idxD} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <Grid style={{ width: '95%', margin: 'auto', backgroundColor: 'rgb(249 249 249)', marginBottom: 20, padding: '10px', cursor: 'pointer' }} container>
                                                        <Grid onClick={() => { this.docActive(d, p) }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                        {this.returnImg(d.type)}
                                                        </Grid>
                                                        <Grid onClick={() => { this.docActive(d, p) }} style={{ textAlign: 'left', paddingLeft: 10 }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                                            <span style={{ fontSize: 14, fontWeight: 600 }}>{d.nume}</span><br />
                                                            <span style={{ color: 'gray', fontSize: 14 }}>{d.type.toUpperCase()}</span>
                                                        </Grid>
                                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                            <span style={{ fontSize: 14, fontWeight: 400 }}>{new Utils().dataPrescurtataRomana(d.cand_uploadat)}</span><br />
                                                            <span style={{ fontSize: 14 }}>{d.nume_t}</span>
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            )
                                        }

                                    } else {
                                        if (idxD < 5) {

                                            if (d.active) {
                                                return (
                                                    <Grid key={idxD} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                        <Grid style={{ width: '95%', margin: 'auto', backgroundColor: 'rgb(249	249	249)', marginBottom: 20, padding: '10px', cursor: 'pointer' }} container>
                                                            <Grid onClick={() => { this.docActive(d, p) }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                            {this.returnImg(d.type)}
                                                            </Grid>

                                                            <Grid onClick={() => { this.docActive(d, p) }} style={{ textAlign: 'left', paddingLeft: 10 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                                <span style={{ fontSize: 14, fontWeight: 600 }}>{d.nume}</span><br />
                                                                <span style={{ color: 'gray', fontSize: 14 }}>{d.type.toUpperCase()}</span>
                                                            </Grid>

                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span style={{ fontSize: 14, fontWeight: 400 }}>{new Utils().dataPrescurtataRomana(d.cand_uploadat)}</span><br />
                                                                <span style={{ fontSize: 14 }}>{d.nume_t}</span>
                                                            </Grid>

                                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                <div style={{ borderLeft: '1px solid gray', height: "100%" }}>
                                                                    <div style={{ display: 'inline-block', height: 'fit-content', marginTop: '24%' }}>
                                                                        <i onClick={() => { this.viewDoc(d, p) }} style={{ marginRight: 10 }} className='material-icons'>visibility</i>
                                                                        <i onClick={() => { this.deleteDoc(d) }} className='material-icons'>delete</i>
                                                                    </div>


                                                                </div>
                                                            </Grid>

                                                        </Grid>
                                                    </Grid>
                                                )
                                            } else {
                                                return (
                                                    <Grid key={idxD} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                        <Grid style={{ width: '95%', margin: 'auto', backgroundColor: 'rgb(249 249 249)', marginBottom: 20, padding: '10px', cursor: 'pointer' }} container>
                                                            <Grid onClick={() => { this.docActive(d, p) }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                            {this.returnImg(d.type)}
                                                            </Grid>
                                                            <Grid onClick={() => { this.docActive(d, p) }} style={{ textAlign: 'left', paddingLeft: 10 }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                                                <span style={{ fontSize: 14, fontWeight: 600 }}>{d.nume}</span><br />
                                                                <span style={{ color: 'gray', fontSize: 14 }}>{d.type.toUpperCase()}</span>
                                                            </Grid>
                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span style={{ fontSize: 14, fontWeight: 400 }}>{new Utils().dataPrescurtataRomana(d.cand_uploadat)}</span><br />
                                                                <span style={{ fontSize: 14 }}>{d.nume_t}</span>
                                                            </Grid>

                                                        </Grid>
                                                    </Grid>
                                                )
                                            }

                                        }

                                    }




                                })}


                                {p.docs.length > 5 &&
                                    <Grid item item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span onClick={() => { this.seeAllDocs(p) }} style={{ color: 'rgb(46	105	179	)', cursor: 'pointer' }}>
                                            {!p.showAllDocs &&
                                                this.dictionary.documenteProiecte.veziToateDocumentele
                                            }

                                            {p.showAllDocs &&
                                                this.dictionary.documenteProiecte.veziMaiPutin
                                            }
                                        </span>
                                    </Grid>
                                }



                            </Grid>
                        )
                    })}
                </Grid>
                {/* <div
                    onClick={() => { this.selectFile('fileproiect') }}
                    className='container'>
                    <h1 className='pm-title'>{this.dictionary.proiecte.segmentButtons.documente}</h1>
                    <div style={{ position: this.state.fullScreen ? '' : 'absolute', top: 0, right: 30, cursor: 'pointer' }}>
                        <i style={{ display: 'block', fontSize: 40, color: '#6f9ce2' }} className='material-icons'>cloud_upload</i>
                        <span className='pm-title'>{this.dictionary.proiecte.informatiiProiect.upload}</span>

                        <input type='file' id={`fileproiect`}
                            style={{ display: 'none' }}
                            accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                            onChange={() => { this.uploadDoc(`fileproiect`, this.props.idproiect) }} />

                    </div>


                </div> */}

                {/* <Grid style={{ maxWidth: 500, margin: 'auto' }} container>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeProiect}
                                checked={this.state.proiecteCheck} />
                            Proiecte</h3>

                    </Grid>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeEtape}
                                checked={this.state.etapeCheck} />
                            Etape</h3>

                    </Grid>

                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeTaskuri}
                                checked={this.state.taskuriCheck} />
                            Taskuri</h3>

                    </Grid>



                </Grid> */}

                {/* 
                <Divider className='pm-divider' />
                <DocumenteList
                    elemente={this.state.listFiltered}
                    dict={this.dictionary}
                    onlyColumns={{ nume: 'nume', data: 'cand_uploadat', doc_info: 'doc_info' }}
                    goToFile={this.goToFile}
                    deleteFile={this.deleteFile}
                />

                <AlertDialog
                    open={this.state.isOpenAlert}
                    dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                    title={this.dictionary.alertDate.document}
                    limba={this.dictionary}
                    yesFunction={this.deleteDoc} /> */}

            </div>
        );
    }
}